// -*- Mode: rjsx -*-
import React, { useState } from 'react';
import moment from 'moment';

import Skeleton from 'react-loading-skeleton';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { FHTheme } from '.';

export default function FancyDate(props) {
    
	let date = props.date;
	let useIcon = props.icon;
    useIcon = false;
    const [absolute, setAbsolute] = useState(props.absolute || false);

	let fancyDate =  {
	    textDecorationStyle: 'dotted',
	    textDecorationColor: "rgb(226, 226, 225)",
	    textDecorationLine: 'underline',
        textDecorationThickness: "1px",
	    cursor: "pointer",
	};
	
	if(!date) {
        return <Skeleton width={85} />;
	}

    let textColor = FHTheme.palette.text.secondary;
    
	let ds = absolute === true ? moment(date).format("LLL") : moment(date).fromNow();
    let icon = useIcon ? <AccessTimeIcon fontSize="small" style={{  paddingTop: "5px", margin: "0px", color: textColor }} /> : null;


    if(props.label)
        return (
            <Grid container>
              <Grid item>{ props.label ? 
		                   <span style={{paddingRight: "5px" }}>{ props.label }:</span> : null }
              </Grid>
              <Grid>
                <Tooltip title={"Click to see " + (absolute ? 'relative': 'absolute') + ' time'} arrow={true}>
		          <span 
                    style={fancyDate}
                    onClick={(e) => { setAbsolute(!absolute); }}>
		            { icon } {ds}          
		          </span>
                </Tooltip>
              </Grid>
            </Grid>
	    );
    else
        return (
            <Tooltip title={"Click to see " + (absolute ? 'relative': 'absolute') + ' time'} arrow={true}>
		      <span 
                style={fancyDate}
                onClick={(e) => { setAbsolute(!absolute); }}>
		        { icon } {ds}          
		      </span>
            </Tooltip>
        );
}
